import { BrandThemeConfig } from './types';
import { cssBrandTokens } from './brandTokens';
import { BRAND_ENV } from './brandEnv';

/**
 * Student runtime config. Visual styling tokens live in public/themes/student.css.
 * cssVariables here are only what MUI theme creation needs at init time.
 */
export const studentBrandConfig: BrandThemeConfig = {
  key: 'student',
  name: 'Sparkl Student',
  buId: BRAND_ENV.student.buId,
  appId: BRAND_ENV.student.appId,
  fontFamily: 'Poppins',
  palette: {
    primary: '#00C8B4',
    secondary: '#FFAA00',
    accent: '#046BCB',
    green: '#008578',
    yellow: '#FFD80B',
  },
  tokens: cssBrandTokens,
  cssVariables: {
    '--brand-background': '#ffffff',
    '--brand-text': '#1a1a1a',
    '--brand-font-family': 'Poppins, sans-serif',
    '--brand-empty-state-bg':
      'linear-gradient(91.14deg, rgba(255, 238, 185, 0) 3.5%, #ffeeb9 92.63%)',
  },
};
